export default {
  /** 配方主数据-获取列表 */
  LIST_FUND_COLLECTION_REGISTER_BY_PAGE: '/produce/sysFormula/queryPage',

  /** 配方主数据保存 */
  ADD_FORMULA: '/produce/sysFormula/save',
  /** 配方主数据删除 */
  DELETE_FORMULA: '/produce/sysFormula/delete',
  /** 配方主数据导入 */
  IMPORT_FORMULA: '/produce/sysFormula/importExcel',
  /** 配方主数据详情 */
  DETAIL_FORMULA: '/produce/sysFormula/queryById',
  /** 配方主数据模糊查询 */
  SELECT_OPTION_FORMULA: '/produce/sysFormula/querySelectOPtion',
  /** 配方主数据-查询所有配方 */
  QUERY_ALL_FORMULA: '/produce/sysFormula/queryAllFormula',
  /** 配方主数据导出 */
  EXPORT_FORMULA: '/produce/sysFormula/exportExcel',
  /** 配方主数据-查询该物料配方下所有的配料详情 */
  QUERY_ALL_FORMULADETAIL: '/produce/sysFormula/queryAllFormulaDetail',
  /** 配方主数据-查询该物料配方下所有的配料详情 */
  QUERY_ALL_PRODUCT: '/produce/sysFormula/queryAllProduct',
  /** 配方主数据-撤销校验账期 */
  QUERY_PDPERIOD: '/produce/pdPeriod/queryPdPeriodList',
};
